<template>
  <div class="room-exam-component justify-center items-center absolute inset-0 lg:grid">
    <div class="room-exam w-full h-full rounded bg-white p-3 pt-12 flex flex-col gap-y-3 relative overflow-hidden lg:w-960 lg:h-4/5 lg:p-10 lg:pt-16 lg:gap-y-5"
         :class="{
           'pb-0': view === 'testbank__exam',
         }"
    >
      <GrmTabs class="absolute top-0 right-0 left-0" :value.sync="testbankTab" :tabs="testbankTabs" />
      <div class="flex justify-between items-center">
        <span class="text-lg font-bold">{{ title }}</span>
        <GrmCloseBtn @click="onClose" />
      </div>
      <div id="roomExamContentComponentWrapper" class="min-h-0 flex-1 -mx-3 px-3 overflow-y-auto lg:-mx-10 lg:px-10">
        <div class="h-full flex flex-col relative">
          <transition name="fade">
            <component class="absolute inset-0" :is="roomExamContentComponent" />
          </transition>
        </div>
      </div>
      <transition name="fade">
        <TestbankInfoFooter v-if="view === 'testbank__exam' && testbankExam.bankExamId" />
      </transition>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";

import GrmTabs from "@/components/Common/tabs/GrmTabs.vue";
import RoomExam from '@/components/Room/Testbank/View/RoomExam.vue'
import GrmCloseBtn from '@/components/Common/button/GrmCloseBtn'
import RoomTestbankList from '@/components/Room/Testbank/RoomTestbankList.vue'
import TestbankExamEdit from '@/components/Room/Testbank/Exam/TestbankExamEdit'
import TestbankExamCopy from '@/components/Room/Testbank/Exam/TestbankExamCopy.vue'
import TestbankInfoFooter from "@/components/Room/Testbank/Info/TestbankInfoFooter.vue";
import RoomTestbankHistory from "@/components/Room/Testbank/History/RoomTestbankHistory.vue";
import TestbankHistoryUser from "@/components/Room/Testbank/History/TestbankHistoryUser.vue";
import RoomTestbankExamList from "@/components/Room/Testbank/Exam/RoomTestbankExamList.vue";
import RoomTestbankExamCreate from '@/components/Room/Testbank/Exam/RoomTestbankExamCreate.vue'
import RoomTestbankHistoryList from "@/components/Room/Testbank/History/RoomTestbankHistoryList.vue";

export default {
  name: 'Testbank',
  components: {
    GrmTabs,
    RoomExam,
    GrmCloseBtn,
    RoomTestbankList,
    TestbankExamEdit,
    TestbankExamCopy,
    TestbankInfoFooter,
    RoomTestbankHistory,
    TestbankHistoryUser,
    RoomTestbankExamList,
    RoomTestbankExamCreate,
    RoomTestbankHistoryList,
  },
  computed: {
    ...mapState('testbank', [
      'view',
      'testbank',
      'testbankExam',
    ]),

    title() {
      return this.testbankTab === 'testbank' ? this.$t('testBank.title') : this.$t('testBank.history');
    },
    roomExamContentComponent() {
      switch (this.view) {
        case 'testbank__list': return 'RoomTestbankList'
        case 'testbank__exam': return 'RoomExam'
        case 'testbank__exam_list': return 'RoomTestbankExamList'
        case 'testbank__exam_create': return 'RoomTestbankExamCreate'
        case 'testbank__exam_edit': return 'TestbankExamEdit'
        case 'testbank__exam_copy': return 'TestbankExamCopy'
        case 'history__list': return 'RoomTestbankHistoryList'
        case 'history__exam': return 'RoomTestbankHistory'
        case 'history__exam__user': return 'TestbankHistoryUser'
        default: return ''
      }
    }
  },
  data() {
    return {
      testbankTab: 'testbank',
      testbankTabs: [
        { value: 'testbank', label: this.$t('testBank.title') },
        { value: 'history', label: this.$t('testBank.history') },
      ],
    }
  },
  created() {
    this.resetTestbank();
  },
  methods: {
    ...mapActions('testbank', [
      'resetTestbank',
    ]),

    onClose() {
      this.$modal('Testbank');
    },
  }
}
</script>

<style lang="scss" scoped>
.room-exam-component {
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 4;
}
.room-exam {
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.6);
}
</style>